import * as React from "react";
import { singleton } from "logic/singleton";
const FieldActionsContext = React.createContext(void 0);
export default singleton("contexts.FieldActionsContext", () => FieldActionsContext);
